export const companyData = {
  googleMapLink: `https://www.google.com/maps/place/25%C2%B040'55.9%22N+51%C2%B029'44.0%22E/@25.6821938,51.4929733,17z/data=!3m1!4b1!4m4!3m3!8m2!3d25.6821938!4d51.4955482?hl=en&entry=ttu`,
  facebook: "#",
  instagram: "#",
  twitter: "#",
  phone: "#",
};
